import { groupFromBE } from '@common/api/groups';
import { programFromBE } from '@common/api/programs';
import backend from '@common/backend';

const BASE = '/programGroups';

export const programGroupFromBE = ({ group, program, ...programGroup }: any) => ({
	// @TODO: Remove when BE will be fixed
	...programGroup,
	group: groupFromBE(group),
	program: program ? programFromBE(program) : null,
});

export const gbProgramGroupFromBE = ({ program, ...programGroup }: any) => ({
	// @TODO: Remove when BE will be fixed
	...programGroup,
	program: program ? programFromBE(program) : null,
});

export const getProgramGroups = async (query: any) => backend.get(`${BASE}/`, { params: query })
	.then((programGroups: any[]) =>
		programGroups.map(programGroupFromBE),
	);

export const createProgramGroup = async (data: any) => backend.post(`${BASE}/`, data);

export const updateProgramGroup = async (group_id: number, data: any) => backend.put(`${BASE}/${group_id}`, data).then(programGroupFromBE);

export const addStudentsToProgramGroup = async (programGroupId: number, student_ids: number[]) =>
	backend.patch(`${BASE}/${programGroupId}/students`, {
		student_ids,
	});

export const removeStudentsFromProgramGroup = async (
	programGroupId: number,
	student_ids: number[],
) =>
	backend.delete(`${BASE}/${programGroupId}/students`, {
		student_ids,
	});

export const transferStudentGroup = async (programGroupId: number, studentId: number, data: any) =>
	backend.patch(`${BASE}/${programGroupId}/students/${studentId}`, data);
